export default __webpack_public_path__ + "static/media/WM0370.34I-43148_-25809_0.56dfc162.jpg";